// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2pBQ2","content":"GlobalSearch_content__w4qfS"};